import { createAction } from 'typesafe-actions';

export const loadAction = createAction('App/Launching')();
export const startedAction = createAction('App/Started')();

export const selectStudy = createAction('App/SelectStudy')();
